import classNames from "classnames";
import React from "react";
import { mapOrUndefined } from "../../utils/mapOrUndefined";
import { withDefault } from "../../utils/withDefault";
import { AppIconColor, getIconColorHex } from "./AppIconColors";

export interface AppIconProps {
  icon: JSX.Element;
  fill?: AppIconColor | string;
  stroke?: AppIconColor | string;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
  onClick?: ($event: React.MouseEvent<HTMLElement>) => void;
}

export const AppIcon = React.forwardRef((props: AppIconProps, ref: React.Ref<SVGElement>) => {
  const fill = mapOrUndefined(props.fill, getIconColorHex);
  const stroke = mapOrUndefined(props.stroke, getIconColorHex);
  const size = withDefault(props.size, 24);

  return React.cloneElement(props.icon, {
    ref: ref,
    "data-with-fill": fill !== undefined,
    "data-with-stroke": stroke !== undefined,
    className: classNames("AppIcon", props.className),
    style: {
      height: size,
      "--fill": fill,
      "--stroke": stroke,
      ...props.style,
    },
    onClick: props.onClick,
  });
});
